import { Modal as AntdModal, Row } from 'antd';
import styled from 'styled-components';

export const Modal = styled(AntdModal)`
  & .ant-modal-content {
    border-radius: 3px;
  }
  & .ant-modal-body {
    padding: 24px 0;
  }
`;

export const HeaderRow = styled(Row)`
  height: 22px;
  padding: 0 20px;
  margin-bottom: 20px;
`;

export const Title = styled.h4`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;

  width: 24px;
  height: 24px;
`;
